(function () {
    'use strict';

    angular.module("imApp").factory("projectsService", ['$ihttp', function ($ihttp) {
        let service = {
            getProjectSettings: function (parms) {
                return $ihttp.post({
                    method: 903,
                    parameters: parms || {}
                });
            },
            listProjects: function (parms) {
                return $ihttp.post({
                    method: 902,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
